import angular from 'angular';
import uiRouter from 'angular-ui-router';
import Common from './common/common';
import Components from './components/components';

import 'normalize.css';


import angularUiBootstrap from 'angular-ui-bootstrap';

import 'bootstrap/dist/css/bootstrap.css';

import './assets/css/font-awesome.min.css';
import './assets/css/themify-icons.css';


import angularAria from 'angular-aria';
import angularAnimate from 'angular-animate';
import angularSpinner from 'angular-spinner';

import ngToast from 'ng-toast';
import 'ng-toast/dist/ngToast.min.css';


import firebase from 'firebase';
import angularfire from 'angularfire';
import angularMessage from 'angular-messages';
import stateEvents from 'angular-ui-router/release/stateEvents.js';


import angularSanitize from 'angular-sanitize';




import angulartics from 'angulartics';
import angularticsMixpanel from 'angulartics-mixpanel';
import angularStripeCheckout from 'angular-stripe-checkout';

import 'ladda/dist/ladda-themeless.min.css';
import 'ladda/dist/spin.min.js';
import 'ladda/dist/ladda.min.js';
import 'angular-ladda/dist/angular-ladda.min.js';

import AppComponent from './app.component';

let selectedEnv = 'prod';

let config = {};


config['local'] = {
  apiKey: "AIzaSyDSrx0YxeHkisnh1waA0rcaLKKJxMfeguo",
  authDomain: "helpscout-integration-dev.firebaseapp.com",
  databaseURL: "https://helpscout-integration-dev.firebaseio.com",
  projectId: "helpscout-integration-dev",
  storageBucket: "helpscout-integration-dev.appspot.com",
  messagingSenderId: "1035516040861",
  SERVERURL: 'http://localhost:8888/v1/',
  stripe_key: 'pk_test_oFexWnviHuftza8d1l4xzLSh'
};

config['prod'] = {
  apiKey: "AIzaSyAlAk_MfuEWS8lju2T0CSAvA2harKhDsHo",
  authDomain: "helpscout-integration-prod.firebaseapp.com",
  databaseURL: "https://helpscout-integration-prod.firebaseio.com",
  projectId: "helpscout-integration-prod",
  storageBucket: "helpscout-integration-prod.appspot.com",
  messagingSenderId: "903403407257",
  SERVERURL: 'https://hsapi.interbot.io/v1/',
  stripe_key: 'pk_test_oFexWnviHuftza8d1l4xzLSh'
};

angular.module('app', [
    uiRouter,
    Common,
    Components,
    angularAria,
    angularAnimate,
    angularfire,
    angularMessage,
    angulartics,
    angularticsMixpanel,
    angularStripeCheckout,
    'angularSpinner',
    'ui.bootstrap',
    'ngToast',
    'ngSanitize',
    'firebase',
    'ui.router.state.events',
    'angular-ladda'
  ])
  .config(($locationProvider, $httpProvider, $analyticsProvider, laddaProvider) => {
    "ngInject";
    $httpProvider.interceptors.push('APIInterceptor');
    $analyticsProvider.virtualPageviews(false);
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(false).hashPrefix('');
    laddaProvider.setOption({ /* optional */
      style: 'expand-right',
      spinnerSize: 35,
      spinnerColor: '#ffffff'
    });
  }).run(function($rootScope, $state) {
    "ngInject";
    firebase.initializeApp(config[selectedEnv]);

    $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
      // We can catch the error thrown when the $requireSignIn promise is rejected
      // and redirect the user back to the home page
      if (error.detail === "AUTH_REQUIRED") {
        $state.go("auth.login");
      }
    });
  })
  .constant('SERVERURL', config[selectedEnv].SERVERURL)
  .constant('STRIPE_KEY', config[selectedEnv].stripe_key)


  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js